import { render, staticRenderFns } from "./ldjs.vue?vue&type=template&id=178c952e&scoped=true"
import script from "./ldjs.vue?vue&type=script&lang=js"
export * from "./ldjs.vue?vue&type=script&lang=js"
import style0 from "./ldjs.vue?vue&type=style&index=0&id=178c952e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178c952e",
  null
  
)

export default component.exports